export default __webpack_public_path__ + "static/media/@eigabbi.25cf2067.png";